import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--up",
  "use": "icon-arrow--up-usage",
  "viewBox": "0 0 22 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 14\" id=\"icon-arrow--up\"><path d=\"m21.577 10.765-9.562-9.562a1.434 1.434 0 0 0-2.032 0L.42 10.765a1.437 1.437 0 0 0 2.032 2.032L11 4.249l8.547 8.549a1.437 1.437 0 1 0 2.032-2.032l-.002-.001Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol